module.exports = __webpack_public_path__ + "img/horizontal_6_2_3016.5e988e6d.png";